<div class="flex flex-column">
    @let list = emails();
    @for (email of list | slice:0:2; track email.id) {
        <app-link-button (clickEvent)="show(email)">
            {{ email.createdAt | localDate }}
        </app-link-button>
    }
    @if (list.length > 0) {
        <app-link-button (clickEvent)="openAll()">...</app-link-button>
    }
</div>
